import { Component } from "solid-js";

import modalStyles from "bundle-text:../styles/_headerModal.scss";

interface HeaderProps {
  title: string;
  onBack?: () => void;
  onClose?: () => void;
}

const HeaderModal: Component<HeaderProps> = ({ title, onBack, onClose }) => {
  return (
    <>
      <style>{modalStyles}</style>
      <header class="__header">
        {onBack && (
          <builderall-icon code="arrow-left" onClick={onBack}></builderall-icon>
        )}
        <p class="__title">{title}</p>
        {onClose && (
          <builderall-icon code="64f7" onClick={onClose}></builderall-icon>
        )}
      </header>
    </>
  );
};

export default HeaderModal;
